import { jsxs as I, jsx as e } from "react/jsx-runtime";
import * as i from "@radix-ui/react-popover";
import u from "classnames";
import { useRef as M } from "react";
import { DATEPICKER_TRIGGER as N } from "./index.es2485.js";
import { useDatePicker as L } from "./index.es851.js";
import a from "./index.es2486.js";
import { useOnKeyPress as $ } from "@placer-ui/hooks";
import { isWithinDateMatrix as S, isWithinRangeDropdown as j } from "./index.es2484.js";
import { CalendarIcon as z } from "./index.es257.js";
import { SimpleTooltip as A } from "./index.es127.js";
import { Button as G } from "./index.es15.js";
const Z = ({
  trigger: n,
  align: g,
  side: h,
  zIndex: D,
  fullWidth: c,
  maxWidth: b,
  placeholder: v,
  children: R,
  ...l
}) => {
  const s = M(null), {
    isOpen: t,
    onClose: d,
    onToggle: w,
    label: o,
    id: r,
    activePanel: C,
    rightMenuRef: p,
    rangeDropdownOpenRef: k,
    focusLeftMenu: x,
    focusLeftDateRangeHeader: y
  } = L(), E = u({
    [a.flipChevronOnCustomTrigger]: n && t
  }), P = {
    zIndex: D
  };
  $("Escape", (T) => {
    var f;
    if (t) {
      if (document.activeElement) {
        if (S(document.activeElement)) {
          y();
          return;
        }
        if (j(
          document.activeElement,
          k.current
        ))
          return;
      }
      if (p.current && p.current.contains(document.activeElement)) {
        x();
        return;
      }
      d(T), ((f = s.current) == null ? void 0 : f.firstChild).focus();
    }
  });
  const O = u(
    a.datepickerLabel,
    o === v && !t ? a.datepickerPlaceholder : ""
  ), m = l["aria-label"] || "Select Date";
  return /* @__PURE__ */ I(i.Root, { open: t, children: [
    /* @__PURE__ */ e(A, { title: o, isActive: C !== "date-range", children: /* @__PURE__ */ e(
      i.Trigger,
      {
        onClick: w,
        className: E,
        asChild: !0,
        style: { width: "100%" },
        children: /* @__PURE__ */ e(
          "div",
          {
            ref: s,
            role: "combobox",
            "aria-label": m,
            "aria-expanded": t,
            "aria-controls": `date-picker-content-${r}`,
            "aria-haspopup": "dialog",
            children: n || /* @__PURE__ */ e(
              G,
              {
                testId: N + r,
                variant: "secondary-gray",
                alignment: c ? "separate" : "center",
                size: "large",
                chevron: {
                  direction: t ? "up" : "down"
                },
                LeftIcon: /* @__PURE__ */ e(z, { outline: "disabled", size: 18 }),
                fullWidth: c,
                "aria-label": m,
                ...l,
                children: /* @__PURE__ */ e(
                  "span",
                  {
                    style: { maxWidth: b, pointerEvents: "none" },
                    className: O,
                    id: `date-picker-label-${r}`,
                    children: o
                  }
                )
              }
            )
          }
        )
      }
    ) }),
    /* @__PURE__ */ e(i.Portal, { children: /* @__PURE__ */ e(
      i.Content,
      {
        sideOffset: 6,
        alignOffset: 20,
        align: g,
        side: h,
        style: P,
        id: `date-picker-content-${r}`,
        "aria-labelledby": `date-picker-label-${r}`,
        onPointerDownOutside: d,
        children: R
      }
    ) })
  ] });
};
export {
  Z as DatePickerDropdown
};
//# sourceMappingURL=index.es852.js.map
